/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Orders_Print_All_FailedInputs */

const en_orders_print_all_failed = /** @type {(inputs: Orders_Print_All_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't print ${i?.label}.`)
};

const es_orders_print_all_failed = /** @type {(inputs: Orders_Print_All_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo imprimir ${i?.label}.`)
};

/**
* | output |
* | --- |
* | "Couldn't print {label}." |
*
* @param {Orders_Print_All_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_print_all_failed = /** @type {((inputs: Orders_Print_All_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Print_All_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_print_all_failed(inputs)
	return es_orders_print_all_failed(inputs)
});